import React from "react";
import AppModal from "../common/AppModal";
import { Alert } from "@mui/material";
import UpdateFiscalIntegrationForm from "../../forms/UpdateFiscalIntegrationForm";

const FiscalIntegrationModal = ({ open, onClose, config, loading, error }) => {
  return (
    <AppModal
      open={open}
      onClose={onClose}
      title="KRA eTIMS Setup"
      width="sm"
      loading={loading}
    >
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}
      <UpdateFiscalIntegrationForm config={config} loading={loading} />
    </AppModal>
  );
};

export default FiscalIntegrationModal;
